import styled from 'styled-components';
import { BodyLarge400, BodySmall500, TitleXSmall500, BodyMedium400 } from '@nebula/global-styles';
import { RadioButton } from '@nebula/radio-button';

export const PricingCards = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const Form = styled.form.attrs({ 'data-track-view': true })``;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${({ $hasFooter }) => ($hasFooter ? 'space-between' : 'center')};
  text-align: left;
  width: 100%;
  min-height: 8.5rem;
  padding: 0;
  border-radius: 0.75rem;
  border: ${({ isSelected }) => (isSelected ? '0.125rem solid #252c34' : '0.0625rem solid #5e6976')};
  background-color: ${({ isSelected }) => (isSelected ? '#f8f8f9' : '#ffffff')};
  cursor: pointer;
  overflow: hidden;
`;

export const CardMain = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: ${({ $hasFooter, $hideRadio }) => {
    if ($hasFooter && $hideRadio) return '2rem 2.5rem 1.25rem';
    if (!$hasFooter && $hideRadio) return '2rem 2.5rem';
    if ($hasFooter) return '1.25rem 1.5rem 0.75rem';
    return '2rem 1.5rem';
  }};
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const CardContent = styled.div`
  display: grid;
  gap: 0;
  align-items: start;
  flex: 1 1 auto;
  min-width: 0;
`;

export const CardRadioContainer = styled.div`
  display: flex;
  align-items: center;
  padding-top: 0.125rem;
`;

export const CardRadio = styled(RadioButton)`
  width: ${props => props.width || '1.25rem'} !important;
  flex-shrink: 0;

  label {
    padding: 0;
    gap: 0;
    width: auto;
    font-size: 0;
    line-height: 0;
  }
`;

export const PricingText = styled.div`
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin: 0.5rem 0;
`;

export const DiscountBadgeContainer = styled.span`
  margin-left: 0;
  display: inline-flex;
  align-items: center;
`;

export const StruckPrice = styled(BodyLarge400).attrs({ as: 'span' })`
  color: #5e6976;
  text-decoration: line-through;
  margin-right: 0.75rem;
`;

export const MonthlyEquivalentBar = styled(BodySmall500)`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: ${({ $hideRadio }) => ($hideRadio ? '0.5rem 2.5rem' : '0.375rem 1rem 0.375rem 3.4375rem')};
  border-radius: 0 0 0.75rem 0.75rem;
  color: #115740;
  background-color: #c7edd3;
`;

export const IntroCopy = styled.div`
  margin-top: 0.5rem;
`;

export const BillingPrompt = styled.p`
  margin: 0.5rem 0 1rem;
  font-family: 'Roboto', sans-serif;
  font-size: 1.125rem;
  line-height: 1.4;
  font-weight: 500;
  color: #000000;
`;

export const Summary = styled.div`
  display: grid;
  grid-gap: 1rem;
  padding: 1rem;
  background-color: ${({ theme }) => theme.color.decorative.sapphire[10]};
  border-radius: 0.75rem;
  a {
    white-space: nowrap;
  }
  @media ${({ theme }) => theme.media.smallDesktopMin} {
    padding: 1.5rem;
  }
`;

export const InfoAlertWrapper = styled.div`
  margin-bottom: 1rem;
`;

export const Product = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  margin: 0.25rem 0 0;
`;

export const Divider = styled.hr`
  height: 0.0625rem;
  margin: 1rem 0;
  background-color: ${({ theme }) => theme.color.decorative.sapphire[20]};
`;

export const SubscriptionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.25rem 0;
`;

export const TermsContainer = styled.div`
  a {
    white-space: nowrap;
  }
`;

export const PlanLabel = styled(TitleXSmall500)`
  margin: 0;
`;

export const PlanPriceContainer = styled.div`
  background-color: ${({ theme }) => theme.color.decorative.sapphire[10]};
  padding: 1.5rem;
  border-radius: 0.75rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1.5rem;
`;

export const LinkContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
`;

export const ViewLabel = styled(BodyMedium400)`
  margin: 0;
`;
